import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import ConfirmationCode from '../../components/ConfirmationCode';
import SignUp from '../../components/SignUp';
import AuthService from '../../services/AuthService';
/**
 * Renders the sign-up component with API call
 *
 * @param {string} [className] - the CSS classes
 * @param {string} [containerClassName] - the CSS classes
 * @param {(response: unknown) => void} [onSuccess] - onSuccess call function
 * @param {(to: string) => void} [onLinkHandler] - links onClick handler
 * @param {(email: string, password: string) => Promise<{ success: boolean; errorMessage: string }>} [apiSignUp] - call this function instead of calling provider automatically.
 * @param {ReactNode | null} => [confirmationStep] - show custom component on instead of typical confirmation.
 * @param {boolean} [skipConfirmation=false] - skip showing confirmation step.
 * @param {string} [inputStyles] - input CSS classes
 * @param {string} [buttonStyles] - btn CSS classes
 * @param {string} [labelStyles] - label CSS classes
 * @param {string} [linkStyles] - link CSS classes
 * @param {string} [formStyles] - form CSS classes
 * @param {string} [formGroupStyles] - form group CSS classes
 *
 * @example
 * <SignUpContainer
 *  className='a6y-react-auth__sign-in'
 *  onSuccess={(response: unknown) => void}
 *  onLinkHandler={onLinkHandler}
 * />
 */
var SignUpContainer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, containerClassName = _a.containerClassName, onSuccess = _a.onSuccess, _c = _a.onLinkHandler, onLinkHandler = _c === void 0 ? undefined : _c, onResponse = _a.onResponse, apiSignUp = _a.apiSignUp, _d = _a.confirmationStep, confirmationStep = _d === void 0 ? null : _d, _e = _a.skipConfirmation, skipConfirmation = _e === void 0 ? false : _e, _f = _a.inputStyles, inputStyles = _f === void 0 ? '' : _f, _g = _a.buttonStyles, buttonStyles = _g === void 0 ? '' : _g, _h = _a.labelStyles, labelStyles = _h === void 0 ? '' : _h, _j = _a.linkStyles, linkStyles = _j === void 0 ? '' : _j, _k = _a.formStyles, formStyles = _k === void 0 ? '' : _k, _l = _a.formGroupStyles, formGroupStyles = _l === void 0 ? '' : _l, _m = _a.consentsHrefStyle, consentsHrefStyle = _m === void 0 ? '' : _m, _o = _a.consentInputLabelStyle, consentInputLabelStyle = _o === void 0 ? '' : _o, _p = _a.consentInputStyle, consentInputStyle = _p === void 0 ? '' : _p, _q = _a.consentTextStyle, consentTextStyle = _q === void 0 ? '' : _q, _r = _a.consentSpanStyle, consentSpanStyle = _r === void 0 ? '' : _r, _s = _a.consentsStyle, consentsStyle = _s === void 0 ? '' : _s, _t = _a.consentsLabelStyle, consentsLabelStyle = _t === void 0 ? '' : _t, formLinkStyle = _a.formLinkStyle, _u = _a.showSocialLogin, showSocialLogin = _u === void 0 ? true : _u, headerComponent = _a.headerComponent;
    var _v = useState(undefined), apiError = _v[0], setApiError = _v[1];
    var _w = useState(false), confirmation = _w[0], setConfirmation = _w[1];
    var _x = useState(''), user = _x[0], setUser = _x[1];
    var _y = useState(false), loader = _y[0], setLoader = _y[1];
    function signUp(email, password, consents) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, success, errorMessage, response, stopExecution, error_1, stopExecution;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoader(true);
                        if (!apiSignUp) return [3 /*break*/, 2];
                        return [4 /*yield*/, apiSignUp(email, password, consents)];
                    case 1:
                        _a = _b.sent(), success = _a.success, errorMessage = _a.errorMessage;
                        if (!success) {
                            setLoader(false);
                            setApiError(errorMessage);
                        }
                        else {
                            setLoader(false);
                            setApiError(undefined);
                        }
                        return [2 /*return*/, null];
                    case 2:
                        _b.trys.push([2, 6, , 9]);
                        return [4 /*yield*/, AuthService.signUp(email, password)];
                    case 3:
                        response = _b.sent();
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 5];
                        return [4 /*yield*/, onResponse('email', email, response)];
                    case 4:
                        stopExecution = _b.sent();
                        _b.label = 5;
                    case 5:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        if (response && response.code) {
                            setLoader(false);
                            setApiError(response.message);
                        }
                        else if (response) {
                            if (onSuccess)
                                onSuccess(response);
                            if (globalThis &&
                                globalThis.A6YReactAuthConfig &&
                                globalThis.A6YReactAuthConfig.components &&
                                globalThis.A6YReactAuthConfig.components.signUp &&
                                globalThis.A6YReactAuthConfig.components.signUp.confirmation) {
                                setConfirmation(true);
                            }
                            setLoader(false);
                            setUser(email);
                        }
                        return [2 /*return*/, null];
                    case 6:
                        error_1 = _b.sent();
                        setLoader(false);
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 8];
                        return [4 /*yield*/, onResponse('email', email, error_1)];
                    case 7:
                        stopExecution = _b.sent();
                        _b.label = 8;
                    case 8:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        setApiError(error_1.message);
                        return [2 /*return*/, null];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }
    function socialSignUp(provider, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, stopExecution, error_2, stopExecution;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoader(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 8]);
                        return [4 /*yield*/, AuthService.socialSignUp(provider, data)];
                    case 2:
                        response = _a.sent();
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 4];
                        return [4 /*yield*/, onResponse(provider, '', response)];
                    case 3:
                        stopExecution = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        if (response && response.code) {
                            setLoader(false);
                            setApiError(response.message);
                        }
                        else if (response) {
                            if (onSuccess)
                                onSuccess(response);
                            setLoader(false);
                        }
                        return [3 /*break*/, 8];
                    case 5:
                        error_2 = _a.sent();
                        setLoader(false);
                        stopExecution = false;
                        if (!onResponse) return [3 /*break*/, 7];
                        return [4 /*yield*/, onResponse(provider, '', error_2)];
                    case 6:
                        stopExecution = _a.sent();
                        _a.label = 7;
                    case 7:
                        if (stopExecution) {
                            return [2 /*return*/];
                        }
                        setApiError(error_2.message);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function confirmSignUp(code) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoader(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, AuthService.confirmSignUp(user, code)];
                    case 2:
                        response = _a.sent();
                        if (response && response.code) {
                            setApiError(response.message);
                            setLoader(false);
                        }
                        else if (response) {
                            if (onSuccess)
                                onSuccess(response);
                            setLoader(false);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        setLoader(false);
                        return [2 /*return*/, setApiError(error_3.message)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement("div", { className: containerClassName ? containerClassName : 'a6y-react-auth__sign-up-cnt' }, confirmation && !skipConfirmation ? (confirmationStep ? (confirmationStep) : (React.createElement(ConfirmationCode, { onClick: confirmSignUp, apiError: apiError }))) : (React.createElement(SignUp, { loader: loader, className: className, onLinkHandler: onLinkHandler, onClick: signUp, onSocialClick: socialSignUp, apiError: apiError, inputStyles: inputStyles, labelStyles: labelStyles, buttonStyles: buttonStyles, linkStyles: linkStyles, formStyles: formStyles, formGroupStyles: formGroupStyles, consentsHrefStyle: consentsHrefStyle, consentInputLabelStyle: consentInputLabelStyle, consentInputStyle: consentInputStyle, consentTextStyle: consentTextStyle, consentsLabelStyle: consentsLabelStyle, consentSpanStyle: consentSpanStyle, consentsStyle: consentsStyle, formLinkStyle: formLinkStyle, showSocialLogin: showSocialLogin, headerComponent: headerComponent }))));
};
export default SignUpContainer;
//# sourceMappingURL=SignUpContainer.js.map